import { render, staticRenderFns } from "./question-para.vue?vue&type=template&id=7bcb7b06&scoped=true&"
import script from "./question-para.vue?vue&type=script&lang=js&"
export * from "./question-para.vue?vue&type=script&lang=js&"
import style0 from "./question-para.vue?vue&type=style&index=0&id=7bcb7b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcb7b06",
  null
  
)

export default component.exports